// Copyright (C) 2021 Bystronic Laser AG

/**
 * Defines available beta features that can be assigned to a user.
 */
export enum BetaFeature {
  WorkCenterConsoleCutCurrentWorkload = 'work-center-console-cut-current-workload',
  WorkCenterConsoleBend = 'work-center-console-bend',
  BackOfficeDeviceBillable = 'back-office-device-billable',
}
